/**
 * Display-name rules, shared by the game and the submission endpoint.
 *
 * The server sanitises independently - a client-side check is a courtesy to
 * the player, never a control - but running the *same* function in both places
 * means what you type is what you see on the board.
 */

import { MAX_NAME_LENGTH } from '../config/leaderboard';

/** Letters (Finnish included), digits, spaces and a few harmless punctuation. */
const ALLOWED = /[^\p{L}\p{N} _.'-]/gu;

export const FALLBACK_NAME = 'Nimetön';

export function sanitisePlayerName(input: unknown): string {
  if (typeof input !== 'string') return FALLBACK_NAME;
  const cleaned = input
    .normalize('NFC')
    // Control characters, zero-width joiners and friends: gone.
    .replace(/[\p{C}\p{Zl}\p{Zp}]/gu, '')
    .replace(ALLOWED, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_NAME_LENGTH)
    .trim();
  return cleaned.length > 0 ? cleaned : FALLBACK_NAME;
}

/** True when the player has actually chosen something. */
export function hasChosenName(input: unknown): boolean {
  return typeof input === 'string' && sanitisePlayerName(input) !== FALLBACK_NAME;
}
